import {
  EDIT_GROUP,
  EDIT_GROUP_CLEAN,
  EDIT_GROUP_SUCCESS,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  group: undefined,
}

const GroupEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_GROUP:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_GROUP_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        group: action.payload.group,
      }
      break
    case EDIT_GROUP_CLEAN:
      state = initialState
      break
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default GroupEdit
